import {Suggest} from "../../../../common/suggest";
import {request} from "../modules/request";

// iOSでひらがな入力中、決定せずにサジェストを選択すると
// 入力されていた文字が残ってしまうためsetTimeoutで対策
Suggest.Local.prototype.setInputText = function(text) {
	this.input.value = text;
	setTimeout(function() {
		this.input.value = text;
		// 長いワードを選択した場合先頭の文字が見えなくなるので
		// フォーカスを外して見えるようにする
		this.input.blur();
	}.bind(this), 100);
};

export default {
	setFreewordSuggestion: function() {
		request("KeywordSuggest", {
			callback: function(data) {
				new Suggest.Local(
					"forcia-freeword",
					"forcia-suggest-freeword",
					data.word,
					{dispMax: 6, interval: 500}
				);
			}
		});
	},
	setHotelNameSuggestion: function() {
		request("KeywordSuggestHotel", {
			callback: function(data) {
				new Suggest.Local(
					"forcia-keyword-hotel",
					"forcia-suggest-hotel",
					data.word,
					{dispMax: 6, interval: 500}
				);
			}
		});
	}
};



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/search/keyword.js